import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";
import { Id } from "@/convex/_generated/dataModel";
import InvoicePublicView from "@/components/invoices/invoice-public-view";
import { Spinner } from "@/components/ui/spinner";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

export const Route = createFileRoute("/_public/shared/invoices/$id")({
  component: PublicInvoicePage,
});

function PublicInvoicePage() {
  const { id } = Route.useParams();

  const invoice = useQuery(api.companies.invoices.queries.getPublicInvoice, {
    id: id as Id<"invoices">,
  });

  const invoiceItems = useQuery(
    api.companies.invoices.items.queries.getPublicInvoiceItemsSorted,
    {
      invoiceId: id as Id<"invoices">,
    },
  );

  const company = useQuery(
    api.companies.queries.getPublicCompanyWithLogo,
    invoice ? { companyId: invoice.internalControl.companyId } : "skip",
  );

  if (
    invoice === undefined ||
    invoiceItems === undefined ||
    company === undefined
  ) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Spinner className="h-8 w-8 mx-auto mb-4" />
          <p className="text-muted-foreground">Cargando factura...</p>
        </div>
      </div>
    );
  }

  if (invoice === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background p-4">
        <Card className="w-full max-w-md">
          <CardHeader>
            <CardTitle className="text-center text-destructive">
              Factura no disponible
            </CardTitle>
          </CardHeader>
          <CardContent>
            <Alert variant="destructive">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>
                La factura que buscas no existe o no esta disponible para
                visualizacion publica.
                <br />
                <br />
                Posibles razones:
                <ul className="list-disc pl-5 mt-2 space-y-1">
                  <li>La factura ha sido cancelada</li>
                  <li>La factura ha sido eliminada</li>
                  <li>El enlace no es valido</li>
                </ul>
              </AlertDescription>
            </Alert>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <InvoicePublicView
        invoice={invoice}
        invoiceItems={invoiceItems || []}
        company={company}
      />
    </div>
  );
}
